// src/AdminConfig/ErrorDialog.js

import React from "react";
import {
    Box,
    Typography,
    Button,
    Backdrop,
} from "@mui/material";

const ErrorDialog = ({ open, onClose, title }) => {

    if (!open) return null;

    return (
        <>
            <Backdrop
                open={open}
                sx={{
                    zIndex: 1999,
                    backgroundColor: "rgba(0,0,0,0.18)",
                    backdropFilter: "blur(2px)",
                }}
            />

            <Box
                sx={{
                    position: "fixed",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    backgroundColor: "#ffffff",
                    borderRadius: "12px",
                    boxShadow: "0 4px 18px rgba(0,0,0,0.08)",
                    border: "1px solid #e5e7eb",
                    padding: "22px 24px",
                    textAlign: "center",
                    zIndex: 2000,
                    width: "320px",
                    fontFamily:
                        '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
                }}
            >

                {/* Small icon */}
                <Box
                    sx={{
                        fontSize: 26,
                        mb: 1.5,
                    }}
                >
                    ⚠️
                </Box>

                {/* Message */}
                <Typography
                    sx={{
                        fontSize: "14px",
                        fontWeight: 400,
                        color: "#4b5563",
                        lineHeight: 1.5,
                        mb: 3,
                    }}
                >
                    {title}
                </Typography>

                {/* Button */}
                <Button
                    variant="contained"
                    onClick={onClose}
                    sx={{
                        backgroundColor: "#1d4ed8",
                        color: "#fff",
                        px: 3,
                        py: 0.8,
                        minWidth: "auto",
                        borderRadius: "8px",
                        textTransform: "none",
                        fontSize: "13px",
                        fontWeight: 500,
                        boxShadow: "none",

                        "&:hover": {
                            backgroundColor: "#1e40af",
                            boxShadow: "none",
                        },
                    }}
                >
                    Close
                </Button>
            </Box>
        </>
    );
};

export default ErrorDialog;